import { graphql } from 'gatsby';
import get from 'lodash/get';
import React from 'react';

import Hero from '../Homepage/Hero';

const RichTextHero: React.FC<{
  node: { data: { target: Queries.RichTextHeroFragment } };
}> = ({ node }) => {
  const entry = get(node, 'data.target');

  if (!entry) {
    console.warn('[RichTextHero] Entry not rendered', { node });
    return null;
  }

  return <Hero hero={entry} />;
};

export default RichTextHero;

export const query = graphql`
  fragment RichTextHero on ContentfulComponentHero {
    __typename
    contentful_id
    theme
    description
    theme
    layout
    image {
      url
      gatsbyImageData(
        formats: [AUTO, AVIF, WEBP]
        quality: 80
        width: 1856
        height: 761
        placeholder: BLURRED
        resizingBehavior: FILL
      )
    }
    mobileImage {
      gatsbyImageData(
        formats: [AUTO, AVIF, WEBP]
        quality: 80
        width: 686
        placeholder: BLURRED
      )
    }
    linkLabel
    title
    link {
      ... on ContentfulPageProduct {
        __typename
        defaultVariant {
          slug
        }
      }
      ... on ContentfulProductVariant {
        __typename
        sku
        slug
      }
      ... on ContentfulPageCategory {
        __typename
        slug
      }
    }
    countdownTimer
  }
`;
